import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import InsightDescription from 'modules/HorseRacing/components/InsightDescription';

require("./InsightDescriptions.scss");

export default class InsightDescriptions extends PureComponent {
  static propTypes = {
    insights: PropTypes.array.isRequired,
    selectedId: PropTypes.string
  };

  render() {
    return (
      <div>
        <div className="insights-header">
          <h1 className="page-main-title-reduced-padding">Insights</h1>
          <p className="insights-header-description">Insights are snippets of information towards a horse's chance that you might otherwise miss! You can read more about the specifics of each Insight below.</p>
        </div>
        <section className="insights-descriptions">
          { this.props.insights.map((insight) => <InsightDescription key={insight.type} selectedId={this.props.selectedId} {...insight}/>) }
        </section>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./modules/HorseRacing/components/InsightDescriptions.js